<template>
  <div class="creditor-main">
    <Menus :menu="menu" @menuClicked="menuClicked" />
    <div class="right-container">
      <TableBox
        :tableData="creditorData"
        title="Creditor Profile"
        :selectedRow.sync="selectedCreditor"
        :loading="tableLoading"
        :dataType="{ 'Job DateTime': 'date' }"
      />
    </div>

    <PopupEntry
      :show.sync="popupEntryShow"
      v-if="popupEntryShow"
      :title="popupEntryTitle"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
      @save="saveClicked"
      :requiredError="entryRequired"
      :successMessages="entrySuccess"
      :messages="entryMessages"
      :errorMessages="entryError"
      :viewMode="viewMode"
      @requiredClicked="entryRequiredClicked"
    >
      <div class="code-section" ref="code-section">
        <Input
          placeholder="Creditor Code"
          :isRequired="true"
          :inputValue.sync="popupContent.popupData.credCode"
          :isDisabled="popupContent.popupData.disabledCredCode"
          :errorMessage.sync="popupContent.popupData.credCodeError"
          ref="Cred_Code"
        />
        <CheckBox
          title="Active"
          style="margin-left: 5px"
          :isChecked.sync="popupContent.popupData.isActive"
          :isDisabled="viewMode"
        />
      </div>

      <Tab
        class="height-100"
        :tabs="tabsItems"
        :tabIndex.sync="currentTab"
        @tabClicked="tabClicked"
        :preventTabSwitch="true"
      >
        <!-- General Details -->
        <div slot="General Details">
          <div class="creditor-general-main">
            <Input
              placeholder="Name"
              :inputValue.sync="popupContent.tabsData[0].data.name"
              :isDisabled="viewMode"
              :isRequired="true"
              :errorMessage.sync="popupContent.tabsData[0].data.nameError"
              ref="Cred_Name"
            />
            <div class="rowBox">
              <Input
                placeholder="Short Name"
                :inputValue.sync="popupContent.tabsData[0].data.shortName"
                :isDisabled="viewMode"
                :isRequired="true"
                :errorMessage.sync="popupContent.tabsData[0].data.sNameError"
                ref="Cred_sName"
              />
            </div>
            <AddressFormV2
              :address.sync="popupContent.tabsData[0].data.address"
              :addressErrors.sync="popupContent.tabsData[0].data.addressErrors"
              :viewMode="viewMode"
              ref="addressForm"
              :postcodes="postcodeList"
              :states="stateList"
              :countries="countryList"
            />
            <div class="rowBox">
              <Input
                placeholder="Phone No"
                style="padding-right: 5px"
                :inputValue.sync="popupContent.tabsData[0].data.phone"
                :isDisabled="viewMode"
                :errorMessage.sync="popupContent.tabsData[0].data.phoneError"
                ref="Cred_Phone"
              />
              <Input
                placeholder="Fax No"
                style="padding-left: 5px"
                :inputValue.sync="popupContent.tabsData[0].data.fax"
                :isDisabled="viewMode"
                :errorMessage.sync="popupContent.tabsData[0].data.faxError"
                ref="Cred_Fax"
              />
            </div>
            <div class="rowBox">
              <Input
                placeholder="Phone No 2"
                style="padding-right: 5px"
                :inputValue.sync="popupContent.tabsData[0].data.phone2"
                :isDisabled="viewMode"
                :errorMessage.sync="popupContent.tabsData[0].data.phone2Error"
                ref="Cred_Phone2"
              />
              <Input
                placeholder="Fax No 2"
                style="padding-left: 5px"
                :inputValue.sync="popupContent.tabsData[0].data.fax2"
                :isDisabled="viewMode"
                :errorMessage.sync="popupContent.tabsData[0].data.fax2Error"
                ref="Cred_Fax2"
              />
            </div>
            <Input
              placeholder="E-Mail"
              :inputValue.sync="popupContent.tabsData[0].data.email"
              :isDisabled="viewMode"
              :errorMessage.sync="popupContent.tabsData[0].data.emailError"
              ref="Cred_Email"
            />
            <div class="rowBox">
              <Input
                placeholder="Credit Limit"
                style="padding-right: 5px"
                :inputValue.sync="popupContent.tabsData[0].data.creditLimit"
                :regex="popupContent.tabsData[0].data.creditLimitRegex"
                :isDisabled="viewMode"
                :errorMessage.sync="popupContent.tabsData[0].data.creditLimitError"
                ref="Cred_CreditLimit"
              />
              <Input
                placeholder="Credit Term"
                style="padding-left: 5px"
                :inputValue.sync="popupContent.tabsData[0].data.creditTerm"
                :regex="popupContent.tabsData[0].data.creditTermRegex"
                :isDisabled="viewMode"
                :errorMessage.sync="popupContent.tabsData[0].data.creditTermError"
                ref="Cred_CreditTerm"
              />
            </div>
            <InputQuery
              :isDisabled="viewMode"
              placeholder="Credit Type"
              :items="popupContent.tabsData[0].data.creditTypeItems"
              itemKey="Description"
              descKey="Credit Type"
              :selectedObject.sync="popupContent.tabsData[0].data.selectedCreditType"
            />
            <InputQuery
              :isDisabled="viewMode"
              placeholder="GL Acc Code"
              :isRequired="true"
              :items="popupContent.tabsData[0].data.GLAccCodeItems"
              itemKey="Description"
              descKey="Acc No"
              :selectedObject.sync="popupContent.tabsData[0].data.selectedGLAccCode"
              :errorMessage.sync="popupContent.tabsData[0].data.GLAccCodeError"
              ref="Cred_GLAccCode"
            />
            <Input
              placeholder="Bank Account No"
              :inputValue.sync="popupContent.tabsData[0].data.bankAcc"
              :regex="popupContent.tabsData[0].data.bankAccRegex"
              :isDisabled="viewMode"
              :errorMessage.sync="popupContent.tabsData[0].data.bankAccError"
              ref="Cred_BankAccNo"
            />
            <div class="rowBox">
              <Dropdown
                placeholder="Category"
                itemKey="Creditor Category"
                :selectedObject.sync="popupContent.tabsData[0].data.selectedCategory"
                :items="popupContent.tabsData[0].data.categoryItems"
                :search.sync="popupContent.tabsData[0].data.categorySearch"
                :isDisabled="viewMode"
                :errorMessage.sync="popupContent.tabsData[0].data.categoryError"
                ref="Cred_Category"
              />
              <InputQuery
                :isDisabled="viewMode"
                placeholder="Internal"
                :items="popupContent.tabsData[0].data.internalItems"
                itemKey="Description"
                descKey="InternalCustType"
                :selectedObject.sync="popupContent.tabsData[0].data.selectedInternal"
                ref="internal"
              />
            </div>
          </div>
        </div>

        <!-- Contact Details -->
        <div slot="Contact Details" class="height-100">
          <Contact
            :person.sync="popupContent.tabsData[1].data.contactPerson"
            :contacts.sync="popupContent.tabsData[1].data.contactItems"
            :viewMode="viewMode"
            :personError.sync="popupContent.tabsData[1].data.contactPersonError"
            ref="contactTab"
            :postcodes="postcodeList"
            :states="stateList"
            :countries="countryList"
            :showInputs.sync="showContactInput"
          />
        </div>

        <!-- Link to Destination -->
        <div slot="Link to Destination" class="height-100">
          <div
            >Link destination points (Pick-Up/Drop-Off) to Creditor Code for HMS system to automatically select creditor
            for payable Depot Gate Charges (DGC) base on Pick-Up/Drop-Off points.</div
          >

          <div v-if="!viewMode" class="buttons">
            <button @click="addDestinationClicked">Add</button>
            <button @click="delDestinationClicked">Delete</button>
          </div>

          <TableBox
            style="height: calc(100% - 100px)"
            title="Destination"
            :tableData="popupContent.tabsData[2].data.destinationItems"
            :maxSelection="-1"
            :selectedRow.sync="popupContent.tabsData[2].data.selectedDestinations"
            :hideColumns="popupContent.tabsData[2].data.hiddenColumns"
          />

          <!-- Add destination Popup -->
          <!-- <PopupEntry :show.sync="destPopupEntryShow" v-if="destPopupEntryShow" :title="'Query Destination'" :createdBy="''" :updatedBy="''" @save="destinationPopupClose(false)" @cancel="destinationPopupClose(true)" :viewMode="viewMode" :saveButton="'Ok'">
            <TableBox style="height: calc(100% - 100px)" title="Destination" :tableData="popupContent.tabsData[2].data.destinationData" :maxSelection="-1" :selectedRow.sync="popupContent.tabsData[2].data.selectedToAddDestinations" />
          </PopupEntry> -->
          <div class="popup-main" v-if="destPopupEntryShow">
            <div class="popup-content">
              <div class="body">
                <TableBox
                  style="height: 100%"
                  title="Query Destination"
                  :tableData="popupContent.tabsData[2].data.destinationData"
                  :maxSelection="-1"
                  :selectedRow.sync="popupContent.tabsData[2].data.selectedToAddDestinations"
                />
              </div>
              <div class="footer">
                <button v-if="!viewMode" @click="destinationPopupClose(false)">
                  <img src="https://dsmlib.logistics.systems/Icons/Save.png" />
                  {{ okButton }}
                </button>
                <button @click="destinationPopupClose(true)">
                  <img src="https://dsmlib.logistics.systems/Icons/Cancel.png" />
                  {{ cancelButton }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Attachments -->
        <div slot="Attachments" class="height-100">
          <Attachments :attachments.sync="popupContent.tabsData[3].data.attachmentItems" :viewMode="viewMode" />
        </div>

        <!-- GST/SST/eInvoice -->
        <div slot="GST/SST/eInvoice">
          <GST :viewMode="viewMode" :gstData.sync="popupContent.tabsData[4].data" ref="gstTab" componentType="creditorTab" />
          <BoxContainer title="SST Details" style="margin-bottom: 20px">
            <Input
              placeholder="License No"
              :inputValue.sync="SSTLicenseNo"
              :isDisabled="viewMode"
              ref="SSTLicenseNo"
              validator="text,50,uppercase"
              :errorMessage.sync="SSTLicenseNoError"
            />
          </BoxContainer>
          <BoxContainer title="LHDN eInvoice Details">
            <div class="lhdn-tin">
              <button @click="validateTaxPayerTin" :disabled="validateTINIcon != ''"> Validate </button>
              <div v-if="validateTINIcon != ''" style="margin-right: -5px; margin-left: 5px">
                <Tooltip :icon="validateTINIcon" :tooltipText="validateTINMsg" />
              </div>
              <Input
                style="margin-left: 5px"
                placeholder="Tax Identification No (TIN)"
                :inputValue.sync="eInvoiceTIN"
                :isDisabled="viewMode"
                ref="eInvoiceTIN"
                validator="text,13,uppercase,alphanumeric,none"
                :errorMessage.sync="eInvoiceTINError"
              />
            </div>
          </BoxContainer>
        </div>

        <!-- EFT -->
        <div slot="EFT" class="height-100">
          <EFT
            :eft.sync="popupContent.tabsData[5].data.eftItems"
            :viewMode="viewMode"
            :showInputs.sync="showEFTInput"
          />
        </div>
      </Tab>
    </PopupEntry>
  </div>
</template>

<script>
import Contact from '@/components/tabComponents/ContactDetails.vue';
import Attachments from '@/components/tabComponents/Attachments.vue';
import GST from '@/components/tabComponents/GSTDetails.vue';
import EFT from '@/components/tabComponents/EFT.vue';

export default {
  components: {
    Contact,
    Attachments,
    GST,
    EFT,
  },
  data: function () {
    return {
      menu: [
        {
          title: 'New Creditor',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          visible: true,
          enabled: true,
          key: 'MnuNew',
        },
        {
          title: 'Edit Creditor',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          visible: true,
          enabled: true,
          key: 'MnuEdit',
        },
        {
          title: 'Delete Creditor',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          visible: false,
          enabled: true,
          key: 'MnuDelete',
        },
        {
          title: 'View Creditor',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          visible: true,
          enabled: true,
          key: 'MnuQuery',
        },
      ],

      creditorData: [],
      selectedCreditor: [],
      postcodeList: [],
      stateList: [],
      countryList: [],
      popupContent: {
        popupData: {
          isActive: false,
          credCode: '',
          credCodeError: '',
          disabledCredCode: false,
          deletedContact: [],
          deletedAttachments: [],
          deletedEft: [],
        },
        tabsData: [
          // Tab 1 - General Details
          {
            data: {
              name: '',
              nameError: '',
              shortName: '',
              sNameError: '',
              address: {
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                addressLine4: '',
                postcode: '',
                city: '',
                state: '',
                country: '',
              },
              addressErrors: {
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                addressLine4: '',
                city: '',
              },
              phone: '',
              phoneError: '',
              fax: '',
              faxError: '',
              phone2: '',
              phone2Error: '',
              fax2: '',
              fax2Error: '',
              email: '',
              emailError: '',
              creditLimit: '',
              creditLimitError: '',
              creditLimitRegex: {
                regex: /\d*\.?\d*/g,
                live: true,
                autoClear: false,
              },
              creditTerm: '',
              creditTermError: '',
              creditTermRegex: {
                regex: /\d/g,
                live: true,
                autoClear: false,
              },
              selectedCreditType: '',
              creditTypeItems: [],
              selectedGLAccCode: null,
              GLAccCodeItems: [],
              GLAccCodeError: '',
              bankAcc: '',
              bankAccError: '',
              bankAccRegex: {
                regex: /\d/g,
                live: true,
                autoClear: false,
              },
              selectedCategory: null,
              categoryItems: [],
              categorySearch: '',
              categoryError: '',
              selectedInternal: null,
              internalItems: [],
            },
          },
          // Tab 2 - Contact Details
          {
            data: {
              contactPerson: '',
              contactPersonError: '',
              contactItems: [],
            },
          },
          // Tab 3 - Link to Destination
          {
            data: {
              selectedDestinations: [],
              destinationItems: [],
              hiddenColumns: [
                '#',
                'Address',
                'PostCode',
                'City',
                'State',
                'Country',
                'Area Name',
                'Office Hours',
                'Secured',
                'Contact',
                'Tel No',
                'Tel No 2',
                'Fax No',
                'Email',
                'ZoneType',
                'ZoneCategory',
                'Type',
                'Transit',
                'Default Remarks',
                'Default Required Time Desc',
                'Opr Area Code',
                'Customer Code',
                'Latitude',
                'Longitude',
                'Height',
                'Geofence',
              ],
              selectedToAddDestinations: [],
              destinationData: [],
            },
          },
          // Tab 4 - Attachments
          {
            data: {
              attachmentItems: [],
            },
          },
          // Tab 5 - GST/SST/eInvoice
          {
            data: {
              comRegNo: '',
              comRegNoError: '',
              taxCodeItems: null,
              msicCodeItems: null,
              selectedMSICCode: null,
              licenseNo: '',
              licenseNoError: '',
              rmcdApprovalNo: '',
              rmcdApprovalNoError: '',
              selectedTaxCode: null,
              dateVerified: null,
            },
          },
          // Tab 6 - EFT
          {
            data: {
              eftItems: [],
            },
          },
        ],
      },
      SSTLicenseNo: '',
      SSTLicenseNoError: '',
      eInvoiceTIN: '',
      eInvoiceTINError: '',
      validateTINIcon: '',
      validateTINMsg: 'Not Validated',

      // Popup entry data
      popupEntryShow: false,
      popupEntryTitle: '',
      createdBy: '',
      updatedBy: '',
      lastUpdate: '',
      viewMode: false,
      entryRequired: [],
      entrySuccess: [],
      entryMessages: [],
      entryError: [],

      currentTab: 0,

      tabsItems: [
        { title: 'General Details', disabled: false },
        { title: 'Contact Details', disabled: false },
        { title: 'Link to Destination', disabled: false },
        { title: 'Attachments', disabled: false },
        { title: 'GST/SST/eInvoice', disabled: false },
        { title: 'EFT', disabled: false },
      ],

      errorMapping: [
        { key: 'Cred_Code', tab: -1 },
        { key: 'Cred_Name', tab: 0 },
        { key: 'Cred_sName', tab: 0 },
        { key: 'Cred_AddressLine1', tab: 0 },
        { key: 'Cred_AddressLine2', tab: 0 },
        { key: 'Cred_AddressLine3', tab: 0 },
        { key: 'Cred_AddressLine4', tab: 0 },
        { key: 'Cred_City', tab: 0 },
        { key: 'Cred_Phone', tab: 0 },
        { key: 'Cred_Fax', tab: 0 },
        { key: 'Cred_Phone2', tab: 0 },
        { key: 'Cred_Fax2', tab: 0 },
        { key: 'Cred_Email', tab: 0 },
        { key: 'Cred_GLAccCode', tab: 0 },
        { key: 'Cred_CreditLimit', tab: 0 },
        { key: 'Cred_CreditTerm', tab: 0 },
        { key: 'Cred_BankAccNo', tab: 0 },
        { key: 'Cred_Category', tab: 0 },
        { key: 'Cred_Contact', tab: 1 },
        { key: 'GST_CompanyRegNo', tab: 4 },
        { key: 'GST_LicenseNo', tab: 4 },
        { key: 'GST_RMCDApprovalNo', tab: 4 },
        { key: 'SSTLicenseNo', tab: 4 },
        { key: 'eInvoiceTIN', tab: 4 },
      ],

      tableLoading: false,

      // Contact tab data
      oriContacts: [],
      showContactInput: false,

      //Link to destination tab data
      // oriDestinations: [],

      // Attachment tab data
      oriAttachmentFiles: [],

      //EFT tab data
      oriEft: [],
      showEFTInput: false,

      destPopupEntryShow: false,

      okButton: 'Ok',
      cancelButton: 'Cancel',
    };
  },
  props: {},
  methods: {
    menuClicked: function (e) {
      this.currentTab = 0;
      switch (e.title) {
        case 'New Creditor':
          this.newClicked();
          this.viewMode = false;
          break;
        case 'Edit Creditor':
          this.viewEditDeleteClicked('edit');
          this.viewMode = false;
          break;
        case 'Delete Creditor':
          this.viewEditDeleteClicked('delete');
          break;
        case 'View Creditor':
          this.viewEditDeleteClicked('view');
          this.viewMode = true;
          break;
      }
    },

    newClicked: function () {
      this.clearMessages();
      this.clearData();

      this.popupEntryTitle = 'New Creditor';
      this.popupEntryShow = true;
      this.popupContent.popupData.disabledCredCode = false;
    },

    viewEditDeleteClicked: async function (status) {
      if (this.selectedCreditor.length > 0) {
        this.clearMessages();
        this.clearData();

        if (status == 'delete') {
          const delCred = await this.$showAlert(
            'warning',
            'Delete Creditor',
            `Are you sure you want to delete Creditor ${this.selectedCreditor[0]['Creditor Name']}?`,
            [{ text: 'Delete' }, { text: 'Cancel' }],
          );
          if (delCred === 'Cancel') {
            return;
          }
        } else {
          this.popupEntryShow = true;
        }

        this.popupContent.popupData.disabledCredCode = true;

        this.$fullscreenLoading("Getting Creditor's Details");
        const details = await this.$apiCallV2('/Master/GetDetailsMaster', {
          recordid: this.selectedCreditor[0]['Creditor Code'].trim(),
          masterfile: 'creditor',
        });
        this.$fullscreenLoading("Getting Creditor's Attachments");
        const attachments = await this.$apiCallV2(
          `/Creditor/GetMasterFileAttachments?refno=${this.selectedCreditor[0]['Creditor Code'].trim()}&tablename=CREDITOR`,
        );
        this.$fullscreenLoading('');

        this.populateCreditor(details.Creditor);
        const contactPerson = details.Creditor['Crd_Contact'] ? details.Creditor['Crd_Contact'].trim() : '';
        this.populateContact(details.Creditor.Contact, contactPerson);
        this.populateDestination(details.Creditor.LinkDestination);
        this.populateAttachments(attachments);
        this.populateGST(details.Creditor.GST);
        this.populateEFT(details.Creditor.EFT);

        this.createdBy =
          details.Creditor['UserCreated'] ?
            `${details.Creditor['UserCreated'].trim()} ${new Date(details.Creditor['TimeCreated']).formatString('dd/MM/yyyy HH:mm')}`
          : '';
        this.updatedBy =
          details.Creditor['UserID'] ?
            `${details.Creditor['UserID'].trim()} ${new Date(details.Creditor['DateUpdate']).formatString('dd/MM/yyyy HH:mm')}`
          : '';
        this.lastUpdate = details.Creditor['DateUpdate'];

        this.popupEntryTitle = status == 'edit' ? 'Edit Creditor' : 'View Creditor (Read Only)';

        if (status == 'delete') {
          this.saveClicked(true);
        } else {
          this.showPopup = true;
        }
      } else {
        this.$showAlert('error', 'No Creditor Selected', `Please select a record to ${status}`);
      }
    },

    saveClicked: async function (isDelete) {
      if (this.showContactInput) {
        const discardChanges = await this.promptDiscardContactChanges();
        if (discardChanges === 'Cancel') {
          return;
        }
        this.showContactInput = false;
      }

      if (this.showEFTInput) {
        const discardChanges = await this.promptDiscardEFTChanges();
        if (discardChanges === 'Cancel') {
          return;
        }
        this.showEFTInput = false;
      }

      if (!isDelete) {
        const isNotValid = this.checkFields();
        if (isNotValid) return;
      }

      this.clearMessages();

      // Setting up contacts
      const contactIDs = this.popupContent.tabsData[1].data.contactItems.map((e) => {
        return e['ID'];
      });
      this.popupContent.popupData.deletedContact = this.oriContacts.filter((e) => {
        return !contactIDs.includes(e.ID);
      });
      const contactToPost = this.popupContent.tabsData[1].data.contactItems.filter((c) => {
        return c.contactaction;
      });
      this.popupContent.popupData.deletedContact.forEach((d) => {
        d.contactaction = 'D';
        contactToPost.push(d);
      });

      const destinationCodes = this.popupContent.tabsData[2].data.destinationItems.map((e) => {
        return e['Destination Code'];
      });
      // this.popupContent.popupData.deletedLinkDestination = this.oriDestinations.filter((e) => { return !destinationCodes.includes(e['Destination Code'])})
      // let destinationToPost = this.popupContent.tabsData[2].data.destinationItems.filter((de) => { return de.destinationaction });
      // this.popupContent.popupData.deletedLinkDestination.forEach((d) => {
      //   d.destinationaction = 'D';
      //   destinationToPost.push(d);
      // });

      // Setting up attachments
      const attachmentIDs = this.popupContent.tabsData[3].data.attachmentItems.map((e) => {
        return e['ID'];
      });
      this.popupContent.popupData.deletedAttachments = this.oriAttachmentFiles.filter((e) => {
        return !attachmentIDs.includes(e.ID);
      });
      const attachmentToPost = this.popupContent.tabsData[3].data.attachmentItems.filter((a) => {
        return a.attachmentaction;
      });
      this.popupContent.popupData.deletedAttachments.forEach((d) => {
        d.attachmentaction = 'D';
        attachmentToPost.push(d);
      });

      // Check attachmentsToPost files to ensure they are not empty
      const emptyAttachmentExists = attachmentToPost.some((attachment) => {
        return !attachment['Attachment'];
      });
      if (emptyAttachmentExists) {
        this.entryError.push('Some files in your attachments have no data!');
        return;
      }

      // Setting up eft
      const eftIDs = this.popupContent.tabsData[5].data.eftItems.map((e) => {
        return e.eftid;
      });
      this.popupContent.popupData.deletedEft = this.oriEft.filter((e) => {
        return !eftIDs.includes(e.eftid);
      });
      const eftToPost = this.popupContent.tabsData[5].data.eftItems.filter((e) => {
        return e.eftaction;
      });
      eftToPost.forEach((p) => {
        p.defaultbank = p.defaultbank ? 1 : 0;
      });
      this.popupContent.popupData.deletedEft.forEach((d) => {
        d.eftaction = 'D';
        eftToPost.push(d);
      });

      const toPost = {
        // DateUpdate: new Date().formatString('yyyy-MM-dd HH:mm:ss'),
        lastupdate: this.lastUpdate ? new Date(this.lastUpdate).formatString('yyyy-MM-dd HH:mm:ss') : '',

        action:
          this.popupEntryTitle == 'New Creditor' ? 'N'
          : isDelete ? 'D'
          : 'E',
        crd_code: this.popupContent.popupData.credCode,
        active: this.popupContent.popupData.isActive ? '1' : '0',
        crd_name: this.popupContent.tabsData[0].data.name,
        crd_sname: this.popupContent.tabsData[0].data.shortName,
        crd_addr1: this.popupContent.tabsData[0].data.address.addressLine1,
        crd_addr2: this.popupContent.tabsData[0].data.address.addressLine2,
        crd_addr3: this.popupContent.tabsData[0].data.address.addressLine3,
        crd_addr4: this.popupContent.tabsData[0].data.address.addressLine4,
        crd_postcode: this.popupContent.tabsData[0].data.address.postcode,
        crd_city: this.popupContent.tabsData[0].data.address.city,
        crd_state: this.popupContent.tabsData[0].data.address.state,
        crd_country: this.popupContent.tabsData[0].data.address.country,
        crd_telno: this.popupContent.tabsData[0].data.phone,
        crd_fax: this.popupContent.tabsData[0].data.fax,
        crd_telno2: this.popupContent.tabsData[0].data.phone2,
        crd_fax2: this.popupContent.tabsData[0].data.fax2,
        crd_email: this.popupContent.tabsData[0].data.email,
        crd_creditlimit: this.popupContent.tabsData[0].data.creditLimit,
        crd_creditterm: this.popupContent.tabsData[0].data.creditTerm,
        crd_credittype:
          this.popupContent.tabsData[0].data.selectedCreditType ?
            this.popupContent.tabsData[0].data.selectedCreditType['Credit Type']
          : '',
        crd_glacccode:
          this.popupContent.tabsData[0].data.selectedGLAccCode ?
            this.popupContent.tabsData[0].data.selectedGLAccCode['Acc No']
          : '',
        crd_bankaccno: this.popupContent.tabsData[0].data.bankAcc,
        crd_category: this.popupContent.tabsData[0].data.categorySearch,
        internal:
          this.popupContent.tabsData[0].data.selectedInternal ?
            this.popupContent.tabsData[0].data.selectedInternal['InternalCustType']
          : '',

        crd_contact: this.popupContent.tabsData[1].data.contactPerson,
        contact: contactToPost,

        destinationarr: destinationCodes.join(','),

        attachment: attachmentToPost,

        gst: {
          gst2coregno: this.popupContent.tabsData[4].data.comRegNo,
          gst2licenseno: this.popupContent.tabsData[4].data.licenseNo,
          gst2rmcdapprovalno: this.popupContent.tabsData[4].data.rmcdApprovalNo,
          gst2taxcode:
            this.popupContent.tabsData[4].data.selectedTaxCode ?
              this.popupContent.tabsData[4].data.selectedTaxCode['Tax Code']
            : '',
          gst2msiccode:
            this.popupContent.tabsData[4].data.selectedMSICCode ?
              this.popupContent.tabsData[4].data.selectedMSICCode['MSIC Code']
            : '',
          gst2datestatusverified:
            this.popupContent.tabsData[4].data.dateVerified ?
              `${this.popupContent.tabsData[4].data.dateVerified.formatString('yyyy-MM-dd HH:mm')}:00`
            : '',
          gstlicenseno: this.SSTLicenseNo,
          tin: this.eInvoiceTIN,
        },

        eft: eftToPost,
      };

      this.$fullscreenLoading('Saving Creditor');
      const save = await this.$apiCallV2('/Creditor/SaveCreditor', toPost);
      this.$fullscreenLoading();

      // Refresh TableBox in Contact Details Tab to view mode (not working)
      // let temp = this.popupContent.tabsData[1].data.contactItems;
      // this.popupContent.tabsData[1].data.contactItems = [];
      // this.$nextTick(() => {
      //   this.popupContent.tabsData[1].data.contactItems = temp;
      //   this.popupContent.tabsData[1].data.selectedContact = [];
      // })

      if (isDelete && save[0].Results == 0) {
        this.$showAlert(
          'success',
          'Deleted',
          `Successfully deleted creditor ${this.popupContent.tabsData[0].data.name}`,
        );
        // Refresh creditor data
        const creditors = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'creditor' });
        this.creditorData = [];
        this.$nextTick(() => {
          this.creditorData = creditors;
          this.selectedCreditor = [];
        });
      }

      if (!isDelete) {
        if (!save) {
          this.entryError.push('Backend Error. Please ensure your inputs are in the correct format.');
        } else if (save[0].Results == 1) {
          this.entryError.push(save[0].ErrMsg);
        } else if (save[0].Results == 0) {
          this.entrySuccess.push('Successfully saved Creditor!');
          this.viewMode = true;
          this.popupContent.popupData.disabledCredCode = true;
          // Refresh creditor data
          const creditors = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'creditor' });
          this.creditorData = [];
          this.$nextTick(() => {
            this.creditorData = creditors;
            this.selectedCreditor = [];
          });
        }
      }
    },

    clearData: function () {
      this.createdBy = '';
      this.updatedBy = '';
      this.lastUpdate = '';

      this.showEFTInput = false;
      this.showContactInput = false;

      this.popupContent.popupData = {
        credCode: '',
        credCodeError: '',
        isActive: false,
        disabledCredCode: false,
        deletedContact: [],
        deletedLinkDestination: [],
        deletedAttachments: [],
        viewMode: false,
      };

      // Clearing Tab 1
      this.popupContent.tabsData[0].data.name = '';
      this.popupContent.tabsData[0].data.shortName = '';
      this.popupContent.tabsData[0].data.address.addressLine1 = '';
      this.popupContent.tabsData[0].data.address.addressLine2 = '';
      this.popupContent.tabsData[0].data.address.addressLine3 = '';
      this.popupContent.tabsData[0].data.address.addressLine4 = '';
      this.popupContent.tabsData[0].data.address.postcode = '';
      this.popupContent.tabsData[0].data.address.city = '';
      this.popupContent.tabsData[0].data.address.state = '';
      this.popupContent.tabsData[0].data.address.country = '';
      this.popupContent.tabsData[0].data.phone = '';
      this.popupContent.tabsData[0].data.fax = '';
      this.popupContent.tabsData[0].data.phone2 = '';
      this.popupContent.tabsData[0].data.fax2 = '';
      this.popupContent.tabsData[0].data.email = '';
      this.popupContent.tabsData[0].data.creditLimit = '';
      this.popupContent.tabsData[0].data.creditTerm = '';
      this.popupContent.tabsData[0].data.selectedCreditType = null;
      this.popupContent.tabsData[0].data.selectedGLAccCode = null;
      this.popupContent.tabsData[0].data.bankAcc = '';
      this.popupContent.tabsData[0].data.selectedCategory = null;
      this.popupContent.tabsData[0].data.categorySearch = '';
      this.popupContent.tabsData[0].data.selectedInternal = null;

      this.popupContent.tabsData[0].data.nameError = '';
      this.popupContent.tabsData[0].data.sNameError = '';
      this.popupContent.tabsData[0].data.addressErrors.addressLine1 = '';
      this.popupContent.tabsData[0].data.addressErrors.addressLine2 = '';
      this.popupContent.tabsData[0].data.addressErrors.addressLine3 = '';
      this.popupContent.tabsData[0].data.addressErrors.addressLine4 = '';
      this.popupContent.tabsData[0].data.addressErrors.city = '';
      this.popupContent.tabsData[0].data.phoneError = '';
      this.popupContent.tabsData[0].data.faxError = '';
      this.popupContent.tabsData[0].data.phone2Error = '';
      this.popupContent.tabsData[0].data.fax2Error = '';
      this.popupContent.tabsData[0].data.emailError = '';
      this.popupContent.tabsData[0].data.creditLimitError = '';
      this.popupContent.tabsData[0].data.creditTermError = '';
      this.popupContent.tabsData[0].data.GLAccCodeError = '';
      this.popupContent.tabsData[0].data.bankAccError = '';
      this.popupContent.tabsData[0].data.categoryError = '';

      // Clearing Tab 2
      this.popupContent.tabsData[1].data.contactPerson = '';
      this.popupContent.tabsData[1].data.contactPersonError = '';
      this.popupContent.tabsData[1].data.contactItems = [];

      // Clearing Tab 3
      this.popupContent.tabsData[2].data.selectedDestinations = [];
      this.popupContent.tabsData[2].data.destinationItems = [];

      // Clearing Tab 4
      this.popupContent.tabsData[3].data.attachmentItems = [];

      // Clearing Tab 5
      this.popupContent.tabsData[4].data.comRegNo = '';
      this.popupContent.tabsData[4].data.comRegNoError = '';
      this.popupContent.tabsData[4].data.licenseNo = '';
      this.popupContent.tabsData[4].data.licenseNoError = '';
      this.popupContent.tabsData[4].data.rmcdApprovalNo = '';
      this.popupContent.tabsData[4].data.rmcdApprovalNoError = '';
      this.popupContent.tabsData[4].data.selectedTaxCode = null;
      this.popupContent.tabsData[4].data.selectedMSICCode = null;
      this.popupContent.tabsData[4].data.dateVerified = null;
      this.SSTLicenseNo = '';
      this.eInvoiceTIN = '';

      //Clearing Tab 6
      this.popupContent.tabsData[5].data.eftItems = [];
      this.oriContacts = [];
      this.oriAttachmentFiles = [];
      this.oriEft = [];

      this.clearMessages();
    },

    clearMessages: function () {
      this.entryMessages = [];
      this.entryError = [];
      this.entryRequired = [];
      this.entrySuccess = [];
    },

    checkFields: function () {
      this.clearMessages();

      if (!this.popupContent.popupData.credCode) {
        this.popupContent.popupData.credCodeError = 'Creditor Code is required!';
        this.entryRequired.push({ key: 'Cred_Code', value: 'Creditor Code is required!' });
      } else if (this.popupContent.popupData.credCode.length > 10) {
        this.popupContent.popupData.credCodeError = 'Creditor Code cannot exceed 10 characters!';
        this.entryRequired.push({ key: 'Cred_Code', value: 'Creditor Code cannot exceed 10 characters!' });
      }
      if (!this.popupContent.tabsData[0].data.name) {
        this.popupContent.tabsData[0].data.nameError = 'Creditor Name is required!';
        this.entryRequired.push({ key: 'Cred_Name', value: 'Creditor Name is required!' });
      } else if (this.popupContent.tabsData[0].data.name.length > 100) {
        this.popupContent.tabsData[0].data.nameError = 'Creditor Name cannot exceed 100 characters!';
        this.entryRequired.push({ key: 'Cred_Name', value: 'Creditor Name cannot exceed 100 characters!' });
      }
      if (!this.popupContent.tabsData[0].data.shortName) {
        this.popupContent.tabsData[0].data.sNameError = 'Creditor Short Name required!';
        this.entryRequired.push({ key: 'Cred_sName', value: 'Creditor Short Name is required!' });
      } else if (this.popupContent.tabsData[0].data.shortName.length > 20) {
        this.popupContent.tabsData[0].data.sNameError = 'Creditor Short Name cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'Cred_sName', value: 'Creditor Short Name cannot exceed 20 characters!' });
      }
      if (this.popupContent.tabsData[0].data.address.addressLine1.length > 40) {
        this.popupContent.tabsData[0].data.addressErrors.addressLine1 = 'Address Line 1 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'Cred_AddressLine1', value: 'Address Line 1 cannot exceed 40 characters!' });
      }
      if (this.popupContent.tabsData[0].data.address.addressLine2.length > 40) {
        this.popupContent.tabsData[0].data.addressErrors.addressLine2 = 'Address Line 2 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'Cred_AddressLine2', value: 'Address Line 2 cannot exceed 40 characters!' });
      }
      if (this.popupContent.tabsData[0].data.address.addressLine3.length > 40) {
        this.popupContent.tabsData[0].data.addressErrors.addressLine3 = 'Address Line 3 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'Cred_AddressLine3', value: 'Address Line 3 cannot exceed 40 characters!' });
      }
      if (this.popupContent.tabsData[0].data.address.addressLine4.length > 40) {
        this.popupContent.tabsData[0].data.addressErrors.addressLine4 = 'Address Line 4 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'Cred_AddressLine4', value: 'Address Line 4 cannot exceed 40 characters!' });
      }
      if (this.popupContent.tabsData[0].data.address.city.length > 30) {
        this.popupContent.tabsData[0].data.addressErrors.city = 'City cannot exceed 30 characters!';
        this.entryRequired.push({ key: 'Cred_City', value: 'City cannot exceed 30 characters!' });
      }
      if (this.popupContent.tabsData[0].data.phone.length > 20) {
        this.popupContent.tabsData[0].data.phoneError = 'Phone No cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'Cred_Phone', value: 'Phone No cannot exceed 20 characters!' });
      }
      if (this.popupContent.tabsData[0].data.fax.length > 20) {
        this.popupContent.tabsData[0].data.faxError = 'Fax No cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'Cred_Fax', value: 'Fax No cannot exceed 20 characters!' });
      }
      if (this.popupContent.tabsData[0].data.phone2.length > 20) {
        this.popupContent.tabsData[0].data.phone2Error = 'Phone No 2 cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'Cred_Phone2', value: 'Phone No 2 cannot exceed 20 characters!' });
      }
      if (this.popupContent.tabsData[0].data.fax2.length > 20) {
        this.popupContent.tabsData[0].data.fax2Error = 'Fax No 2 cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'Cred_Fax2', value: 'Fax No 2 cannot exceed 20 characters!' });
      }
      if (this.popupContent.tabsData[0].data.email.length > 40) {
        this.popupContent.tabsData[0].data.emailError = 'Email cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'Cred_Email', value: 'Email cannot exceed 40 characters!' });
      }
      if (!this.popupContent.tabsData[0].data.selectedGLAccCode) {
        this.popupContent.tabsData[0].data.GLAccCodeError = 'GL Acc Code is required!';
        this.entryRequired.push({ key: 'Cred_GLAccCode', value: 'GL Acc Code is required!' });
      }
      if (
        !this.popupContent.tabsData[0].data.creditLimit.match(/^\d*\.?\d*$/g) &&
        this.popupContent.tabsData[0].data.creditLimit
      ) {
        this.popupContent.tabsData[0].data.creditLimitError = 'Credit Limit format error!';
        this.entryRequired.push({
          key: 'Cred_CreditLimit',
          value: 'Credit Limit format error! Please make sure input is in money format.',
        });
      } else if (Number(this.popupContent.tabsData[0].data.creditLimit) > 900000000000000) {
        this.popupContent.tabsData[0].data.creditLimitError = 'Credit Limit cannot exceed 900,000,000,000,000!';
        this.entryRequired.push({ key: 'Cred_CreditLimit', value: 'Credit Limit cannot exceed 900,000,000,000,000!' });
      }
      if (Number(this.popupContent.tabsData[0].data.creditTerm) > 2000000000) {
        this.popupContent.tabsData[0].data.creditTermError = 'Credit Term cannot exceed 2,000,000,000!';
        this.entryRequired.push({ key: 'Cred_CreditTerm', value: 'Credit Term cannot exceed 2,000,000,000!' });
      }
      if (this.popupContent.tabsData[0].data.bankAcc.length > 50) {
        this.popupContent.tabsData[0].data.bankAccError = 'Bank Account No cannot exceed 50 characters!';
        this.entryRequired.push({ key: 'Cred_BankAccNo', value: 'Bank Account No cannot exceed 50 characters!' });
      }
      if (this.popupContent.tabsData[0].data.categorySearch.length > 10) {
        this.popupContent.tabsData[0].data.categoryError = 'Category cannot exceed 10 characters!';
        this.entryRequired.push({ key: 'Cred_Category', value: 'Category cannot exceed 10 characters!' });
      }

      if (this.popupContent.tabsData[1].data.contactPerson.length > 100) {
        this.popupContent.tabsData[1].data.contactPersonError = 'Contact Person cannot exceed 100 characters!';
        this.entryRequired.push({ key: 'Cred_Contact', value: 'Contact Person cannot exceed 100 characters!' });
      }

      if (this.popupContent.tabsData[4].data.comRegNo.length > 25) {
        this.popupContent.tabsData[4].data.comRegNoError = 'Company Registration No. cannot exceed 25 characters!';
        this.entryRequired.push({
          key: 'GST_CompanyRegNo',
          value: 'Company Registration No. cannot exceed 25 characters!',
        });
      }

      if (this.popupContent.tabsData[4].data.licenseNo.length > 50) {
        this.popupContent.tabsData[4].data.licenseNoError = 'License No cannot exceed 50 characters!';
        this.entryRequired.push({ key: 'GST_LicenseNo', value: 'License No cannot exceed 50 characters!' });
      }
      if (this.popupContent.tabsData[4].data.rmcdApprovalNo.length > 25) {
        this.popupContent.tabsData[4].data.rmcdApprovalNoError = 'RMCD Approval No cannot exceed 25 characters!';
        this.entryRequired.push({ key: 'GST_RMCDApprovalNo', value: 'RMCD Approval No cannot exceed 25 characters!' });
      }
      if (this.SSTLicenseNo.length > 50) {
        this.SSTLicenseNoError = 'SST License No cannot exceed 50 characters!';
        this.entryRequired.push({ key: 'SSTLicenseNo', value: 'SST License No cannot exceed 50 characters!' });
      }
      if (this.eInvoiceTIN.length > 13) {
        this.eInvoiceTINError = 'Tax Identification No (TIN) cannot exceed 13 characters!';
        this.entryRequired.push({
          key: 'eInvoiceTIN',
          value: 'Tax Identification No (TIN) cannot exceed 13 characters!',
        });
      }

      return this.entryRequired.length > 0;
    },

    populateObject: function (data, key, compare) {
      // To populate object into dropdown or input query
      try {
        return data.find((d) => d[key].trim() == (compare ? compare.trim() : ''));
      } catch (error) {
        return null;
      }
    },

    populateCreditor: function (creditor) {
      this.popupContent.popupData.credCode = creditor['Crd_Code'] ? creditor['Crd_Code'].trim() : '';
      this.popupContent.popupData.isActive = creditor['Active'] == '1';

      this.popupContent.tabsData[0].data.name = creditor['Crd_Name'] ? creditor['Crd_Name'].trim() : '';
      this.popupContent.tabsData[0].data.shortName = creditor['Crd_sName'] ? creditor['Crd_sName'].trim() : '';
      this.popupContent.tabsData[0].data.address.addressLine1 =
        creditor['Crd_Addr1'] ? creditor['Crd_Addr1'].trim() : '';
      this.popupContent.tabsData[0].data.address.addressLine2 =
        creditor['Crd_Addr2'] ? creditor['Crd_Addr2'].trim() : '';
      this.popupContent.tabsData[0].data.address.addressLine3 =
        creditor['Crd_Addr3'] ? creditor['Crd_Addr3'].trim() : '';
      this.popupContent.tabsData[0].data.address.addressLine4 =
        creditor['Crd_Addr4'] ? creditor['Crd_Addr4'].trim() : '';
      this.popupContent.tabsData[0].data.address.postcode =
        creditor['Crd_PostCode'] ? creditor['Crd_PostCode'].trim() : '';
      this.popupContent.tabsData[0].data.address.city = creditor['Crd_City'] ? creditor['Crd_City'].trim() : '';
      this.popupContent.tabsData[0].data.address.state = creditor['Crd_State'] ? creditor['Crd_State'].trim() : '';
      this.popupContent.tabsData[0].data.address.country =
        creditor['Crd_Country'] ? creditor['Crd_Country'].trim() : '';
      this.popupContent.tabsData[0].data.phone = creditor['Crd_TelNo'] ? creditor['Crd_TelNo'].trim() : '';
      this.popupContent.tabsData[0].data.fax = creditor['Crd_Fax'] ? creditor['Crd_Fax'].trim() : '';
      this.popupContent.tabsData[0].data.phone2 = creditor['Crd_TelNo2'] ? creditor['Crd_TelNo2'].trim() : '';
      this.popupContent.tabsData[0].data.fax2 = creditor['Crd_Fax2'] ? creditor['Crd_Fax2'].trim() : '';
      this.popupContent.tabsData[0].data.email = creditor['Crd_Email'] ? creditor['Crd_Email'].trim() : '';
      this.popupContent.tabsData[0].data.creditLimit =
        creditor['Crd_CreditLimit'] ? creditor['Crd_CreditLimit'].trim() : '';
      this.popupContent.tabsData[0].data.creditTerm =
        creditor['Crd_CreditTerm'] ? creditor['Crd_CreditTerm'].trim() : '';
      const creditType = creditor['Crd_CreditType'] ? creditor['Crd_CreditType'].trim() : '';
      this.popupContent.tabsData[0].data.selectedCreditType = this.populateObject(
        this.popupContent.tabsData[0].data.creditTypeItems,
        'Credit Type',
        creditType,
      );
      const GLAccCode = creditor['Crd_GLAcc'] ? creditor['Crd_GLAcc'].trim() : '';
      this.popupContent.tabsData[0].data.selectedGLAccCode = this.populateObject(
        this.popupContent.tabsData[0].data.GLAccCodeItems,
        'Acc No',
        GLAccCode,
      );
      this.popupContent.tabsData[0].data.bankAcc = creditor['Crd_BankAccNo'] ? creditor['Crd_BankAccNo'].trim() : '';
      this.popupContent.tabsData[0].data.categorySearch =
        creditor['Crd_Category'] ? creditor['Crd_Category'].trim() : '';
      const internal = creditor['Internal'] ? creditor['Internal'].trim() : '';
      this.popupContent.tabsData[0].data.selectedInternal = this.populateObject(
        this.popupContent.tabsData[0].data.internalItems,
        'InternalCustType',
        internal,
      );
    },

    populateContact: function (contact, contactPerson) {
      if (!contact) {
        return;
      }

      if (!Array.isArray(contact)) {
        contact = [contact];
      }

      this.popupContent.tabsData[1].data.contactPerson = contactPerson ? contactPerson.trim() : '';
      contact.forEach((c) => {
        const contactEntry = {
          contactaction: '',
          ID: c.ID ? c.ID.trim() : '',
          ContactPerson: c.ContactPerson ? c.ContactPerson.trim() : '',
          TitlePosition: c.TitlePosition ? c.TitlePosition.trim() : '',
          Department: c.Department ? c.Department.trim() : '',
          Addr1: c.Addr1 ? c.Addr1.trim() : '',
          Addr2: c.Addr2 ? c.Addr2.trim() : '',
          Addr3: c.Addr3 ? c.Addr3.trim() : '',
          Addr4: c.Addr4 ? c.Addr4.trim() : '',
          PostCode: c.PostCode ? c.PostCode.trim() : '',
          City: c.City ? c.City.trim() : '',
          State: c.State ? c.State.trim() : '',
          Country: c.Country ? c.Country.trim() : '',
          TelNo: c.TelNo ? c.TelNo.trim() : '',
          MobileNo: c.MobileNo ? c.MobileNo.trim() : '',
          FaxNo: c.FaxNo ? c.FaxNo.trim() : '',
          Email: c.Email ? c.Email.trim() : '',
          Remarks: c.Remarks ? c.Remarks.trim() : '',
        };
        this.popupContent.tabsData[1].data.contactItems.push(contactEntry);
        this.oriContacts.push(contactEntry);
      });
    },

    populateDestination: function (destination) {
      if (!destination) {
        return;
      }

      destination.forEach((d) => {
        let destinationEntry = {
          // destinationaction: '',
          DestinationCode: d['Destination Code'] ? d['Destination Code'].trim() : '',
        };
        destinationEntry = this.popupContent.tabsData[2].data.destinationData.filter((dd) => {
          return dd['Destination Code'].trim() == destinationEntry.DestinationCode.trim();
        });
        this.popupContent.tabsData[2].data.destinationItems.push(...destinationEntry);
        // this.oriDestinations.push(destinationEntry)
      });
    },

    populateAttachments: function (attachments) {
      attachments.forEach((a) => {
        const attachmentEntry = {
          attachmentaction: '',
          ID: a['ID'],
          FileName: a['File Name'],
          Remarks: a['Remarks'],
          Attachment: a['Attachment'],
        };
        this.popupContent.tabsData[3].data.attachmentItems.push(attachmentEntry);
        this.oriAttachmentFiles.push(attachmentEntry);
      });
    },

    populateGST: function (gst) {
      if (!gst) {
        return;
      }

      this.popupContent.tabsData[4].data.comRegNo = gst['GST2CoRegNo'];
      this.popupContent.tabsData[4].data.dateVerified =
        gst['GST2DateStatusVerified'] ? new Date(gst['GST2DateStatusVerified']) : null;
      this.popupContent.tabsData[4].data.licenseNo = gst['GST2LicenseNo'];
      this.popupContent.tabsData[4].data.rmcdApprovalNo = gst['GST2RMCDApprovalNo'];

      if (gst['GST2TaxCode']) {
        const selectedTax = this.popupContent.tabsData[4].data.taxCodeItems.filter((t) => {
          return t['Tax Code'].trim() == gst['GST2TaxCode'].trim();
        });
        this.popupContent.tabsData[4].data.selectedTaxCode = selectedTax[0];
      }

      if (gst['GST2MSICCode']) {
        const selectedMSICCode = this.popupContent.tabsData[4].data.msicCodeItems.filter((m) => {
          return m['MSIC Code'].trim() == gst['GST2MSICCode'].trim();
        });
        this.popupContent.tabsData[4].data.selectedMSICCode = selectedMSICCode[0];
      }

      this.SSTLicenseNo = gst['GSTLicenseNo'] ? gst['GSTLicenseNo'] : '';
      this.eInvoiceTIN = gst['TIN'] ? gst['TIN'] : '';
    },

    populateEFT: function (eft) {
      if (!eft) {
        return;
      }

      if (!Array.isArray(eft)) {
        eft = [eft];
      }

      eft.forEach((e) => {
        const eftEntry = {
          eftaction: '',
          eftid: e.ID ? e.ID.trim() : '',
          bankswiftcode: e.BankSwiftCode ? e.BankSwiftCode.trim() : '',
          bankaccno: e.BankAccount ? e.BankAccount.trim() : '',
          bankcity: e.BankCity ? e.BankCity.trim() : '',
          defaultbank: e['DefaultAccount'] == '1',
          bankname: e.BankName ? e.BankName.trim() : '',
          bankbranchname: e.BankBranchName ? e.BankBranchName.trim() : '',
          emailremittanceadvice: e.RemittanceAdviceEmail ? e.RemittanceAdviceEmail.trim() : '',
          eftlastupdate: e['EFT Last Update'],
        };
        this.popupContent.tabsData[5].data.eftItems.push(eftEntry);
        this.oriEft.push(eftEntry);
      });
    },

    setSASControl: function (sasControl) {
      sasControl.forEach((k) => {
        //key in menu same as control value from api
        const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
        if (selectedMenu) {
          selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
        }
      });
    },

    entryRequiredClicked: function (item) {
      const errorTab = this.errorMapping.find((e) => e['key'] == item);

      if (errorTab && errorTab['tab'] >= 0) {
        this.currentTab = errorTab['tab'];
      }

      this.$nextTick(() => {
        switch (errorTab['key']) {
          case 'Cred_AddressLine1':
            this.$refs['addressForm'].setFocus('address1');
            break;

          case 'Cred_AddressLine2':
            this.$refs['addressForm'].setFocus('address2');
            break;

          case 'Cred_AddressLine3':
            this.$refs['addressForm'].setFocus('address3');
            break;

          case 'Cred_AddressLine4':
            this.$refs['addressForm'].setFocus('address4');
            break;

          case 'Cred_City':
            this.$refs['addressForm'].setFocus('city');
            break;

          case 'Cred_Contact':
            this.$refs['contactTab'].focusContactPersonInput();
            break;

          case 'GST_CompanyRegNo':
            this.$refs['gstTab'].focusGSTInput('comregno');
            break;

          case 'GST_LicenseNo':
            this.$refs['gstTab'].focusGSTInput('licenseno');
            break;

          case 'GST_RMCDApprovalNo':
            this.$refs['gstTab'].focusGSTInput('rmcdapprovalno');
            break;

          default:
            this.$refs[item].setFocus();
            break;
        }
      });
    },

    addDestinationClicked: function () {
      this.destPopupEntryShow = true;
      this.popupContent.tabsData[2].data.selectedToAddDestinations = [
        ...this.popupContent.tabsData[2].data.destinationItems,
      ];
    },

    delDestinationClicked: function () {
      if (this.popupContent.tabsData[2].data.selectedDestinations.length < 1) {
        this.$showAlert(
          'error',
          'No Destination Selected',
          'Please select at least one destination from the list below to delete',
        );
        return;
      }
      const temp = this.popupContent.tabsData[2].data.destinationItems;
      this.popupContent.tabsData[2].data.destinationItems = [];
      this.popupContent.tabsData[2].data.selectedDestinations.forEach((s) => {
        const index = temp.findIndex((i) => i['Destination Code'] === s['Destination Code']);
        temp.splice(index, 1);
      });

      this.$nextTick(() => {
        this.popupContent.tabsData[2].data.destinationItems = temp;
        this.popupContent.tabsData[2].data.selectedDestinations = [];
      });
    },

    destinationPopupClose: function (isCancelButton) {
      if (!isCancelButton) {
        // if (this.popupContent.tabsData[2].data.selectedToAddDestinations.length < 1) {
        //   this.$showAlert('error', 'No Destination Selected', 'Please select at least one destination to add');
        //   return;
        // }
        // else {
        //   let destinationCodes = this.popupContent.tabsData[2].data.destinationItems.map((c) => {return c['Destination Code']})
        //   let temp = this.popupContent.tabsData[2].data.destinationItems;
        //   this.popupContent.tabsData[2].data.destinationItems = [];
        //   this.popupContent.tabsData[2].data.selectedToAddDestinations.forEach(s => {
        //     if (!destinationCodes.includes(s['Destination Code'])) {
        //       temp.push(s);
        //     }
        //     this.$nextTick(() => {
        //       this.popupContent.tabsData[2].data.destinationItems = temp;
        //       this.popupContent.tabsData[2].data.selectedDestinations = [];
        //     });
        //   })
        // }
        this.popupContent.tabsData[2].data.destinationItems = [];
        const temp = [...this.popupContent.tabsData[2].data.selectedToAddDestinations];
        this.$nextTick(() => {
          this.popupContent.tabsData[2].data.destinationItems = temp;
          this.popupContent.tabsData[2].data.selectedDestinations = [];
        });
      }
      this.destPopupEntryShow = false;
      this.popupContent.tabsData[2].data.selectedToAddDestinations = [];
    },

    validateTaxPayerTin: async function () {
      if (!this.eInvoiceTIN.startsWith('EI') && (!this.popupContent.tabsData[4].data.comRegNo || this.popupContent.tabsData[4].data.comRegNo == '')) {
        this.$showAlert('error', 'Missing ID Number', 'Please key in New Comp Reg No');
        return;
      }

      this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/LoadingCircle.gif';
      this.validateTINMsg = 'Validating';

      const jsonBody = {
        tin: this.eInvoiceTIN,
        brn: this.popupContent.tabsData[4].data.comRegNo,
      };
      const result = await this.$apiCallV2('/ARInvoice/ValidateTaxpayerTin', jsonBody);
      if (result?.[0]?.['Results'] == 0) {
        this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/Save.png';
        this.validateTINMsg = 'Valid Taxpayer TIN';
      } else {
        this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/Cancel.png';
        this.validateTINMsg = `Invalid Taxpayer TIN (${result?.[0]?.['ErrMsg']})`;
      }
    },

    tabClicked: async function (_tabItem, tabIndex) {
      if (this.showContactInput && tabIndex !== 1) {
        const discardChanges = await this.promptDiscardContactChanges();
        if (discardChanges === 'Cancel') {
          return;
        }
        this.showContactInput = false;
      }

      if (this.showEFTInput && tabIndex !== 5) {
        const discardChanges = await this.promptDiscardEFTChanges();
        if (discardChanges === 'Cancel') {
          return;
        }
        this.showEFTInput = false;
      }

      this.currentTab = tabIndex; // change to the tab user clicked on
    },

    promptDiscardContactChanges: function () {
      // $showAlert returns a promise, which can be awiated in the calling functin to get the button clicked by the user
      return this.$showAlert(
        'warning',
        'Discard Changes',
        'You have unsaved contact changes. <br>Do you wish to discard the changes?',
        [{ text: 'Discard', color: 'Red', textColor: 'white' }, { text: 'Cancel' }],
      );
    },

    promptDiscardEFTChanges: function () {
      // $showAlert returns a promise, which can be awiated in the calling functin to get the button clicked by the user
      return this.$showAlert(
        'warning',
        'Discard Changes',
        'You have unsaved EFT changes. <br>Do you wish to discard the changes?',
        [{ text: 'Discard', color: 'Red', textColor: 'white' }, { text: 'Cancel' }],
      );
    },
  },
  async mounted() {
    this.clearData();

    this.$fullscreenLoading('Getting Creditors');
    const creditor = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'creditor' });
    this.creditorData = creditor;

    this.$fullscreenLoading('Getting Postcodes');
    this.postcodeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'postcode' });
    // this.popupContent.tabsData[0].data.postcodeItems = postcode;

    this.$fullscreenLoading('Getting States');
    this.stateList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'state' });
    // this.popupContent.tabsData[0].data.stateItems = states;

    this.$fullscreenLoading('Getting Country');
    this.countryList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'country' });

    // this.popupContent.tabsData[0].data.countryItems = countries;

    this.$fullscreenLoading('Getting Credit Type');
    const creditTypes = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'credittype' });
    this.popupContent.tabsData[0].data.creditTypeItems = creditTypes;

    this.$fullscreenLoading('Getting GL Acc');
    const glAcc = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'glaccount' });
    this.popupContent.tabsData[0].data.GLAccCodeItems = glAcc;

    this.$fullscreenLoading('Getting Category');
    const categories = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'creditor_category' });
    categories.forEach((c) => {
      c['Creditor Category'] = c['Creditor Category'].trim();
    });
    this.popupContent.tabsData[0].data.categoryItems = categories;

    this.$fullscreenLoading('Getting Internal');
    const internals = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'internalcusttype' });
    this.popupContent.tabsData[0].data.internalItems = internals;

    this.$fullscreenLoading('Getting Destination');
    const destinations = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'destination' });
    this.popupContent.tabsData[2].data.destinationData = destinations;

    this.$fullscreenLoading('Getting Tax Codes');
    const taxCodes = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'aptaxcode' });
    taxCodes.forEach((t) => {
      t['Tax Code'] = t['Tax Code'] ? t['Tax Code'].trim() : '';
      t['Tax Code Desc'] = t['Tax Code Desc'] ? t['Tax Code Desc'].trim() : '';
      t['Tax Type'] = t['Tax Type'] ? t['Tax Type'].trim() : '';
    });
    this.popupContent.tabsData[4].data.taxCodeItems = taxCodes.map((item) => {
      return {
        ...item,
        'Tax Code - Tax Code Desc': `${item['Tax Code']} - ${item['Tax Code Desc']}`,
      };
    });

    this.$fullscreenLoading('Getting MSIC Codes');
    const msicCodes = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'MSIC' });
    this.popupContent.tabsData[4].data.msicCodeItems = msicCodes;

    this.$fullscreenLoading('Setting SAS Control');
    const sasControl = await this.$apiCallV2('/SASControl/GetSASControlAccess?system=Master&page=Creditor');
    this.setSASControl(sasControl);

    this.$fullscreenLoading();

    //shortcut to create new creditor: https://localhost:5001/Home/u0/MasterFiles/ProfileMaster/Creditor?new=1
    if (this.$route.query['new']) {
      this.menuClicked({ title: 'New Creditor' });
    }
  },
  watch: {
    showPopup: function (val) {
      if (!val) {
        this.clearData();
        this.clearMessages();
      }
    },

    //Update contact
    contactPerson: function (val) {
      this.$emit('update:person', val);
    },

    popupEntryShow: async function (val) {
      if (!val && this.$route.query['new'] && !this.viewMode) {
        // When the cancel is click but is not saved (for query new=1)
        const closeWindow = await this.$showAlert(
          'warning',
          'Cancelling Creditor Creation',
          `You have not created an Creditor profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`,
          [{ text: 'Continue Creating' }, { text: 'Cancel Creating', color: 'red', textColor: 'white' }],
        );

        if (closeWindow == 'Cancel Creating') {
          // If user choose to cancel the creating process, it will close the tab
          window.close();
        } else {
          this.popupEntryShow = true;
        }
      } else if (!val && this.$route.query['new'] && this.viewMode) {
        window.close();
      }
    },

    eInvoiceTIN: function () {
      this.validateTINIcon = '';
    },

    'popupContent.tabsData.4.data.comRegNo': function() {
      this.validateTINIcon = '';
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.creditor-main {
  width: 100%;
  height: 100%;
  display: flex;
  // background-color: yellow;
  padding: 10px 45px;
  font-size: 12px;
}

.right-container {
  width: 100%;
  overflow: hidden;
  height: 100%;
  padding: 5px;
  border-radius: 5px;
  margin-left: 5px;
  background-color: white;
}

.height-100 {
  height: 100%;
}

// Checkbox
.code-section {
  display: flex;
}

.rowBox {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: 0.3s;
}

.buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 5px;

  > button {
    margin: 3px;
  }
}

.popup-main {
  height: calc(100% - #{$top-nav-height});
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: $top-nav-height;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 42px;
  z-index: 999;

  > .popup-content > * {
    padding: 5px;
  }

  > .popup-content {
    width: 85%;
    height: 85%;
    background-color: white;
    border-radius: 3px;
    display: flex;
    flex-direction: column;

    > .body {
      overflow-y: hidden;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    > .footer {
      // border-top: 2px solid rgb(180,180,180);
      display: flex;
      align-items: center;
      justify-content: center;

      > button {
        padding: 5px;
        margin: 10px 3px;

        > img {
          height: 25px;
        }
      }
    }
  }
}

.lhdn-tin {
  display: flex;
  flex-direction: row;
}
</style>
